"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconLandmarkMountain = /*#__PURE__*/
function (_Icon) {
  _inherits(IconLandmarkMountain, _Icon);
  function IconLandmarkMountain(props) {
    var _this;
    _classCallCheck(this, IconLandmarkMountain);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconLandmarkMountain).call(this, props));
    _this.name = 'IconLandmarkMountain';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "landmark-mountain_svg__group0"
    }, _react2.default.createElement("path", {
      className: "landmark-mountain_svg__path0",
      d: "M19 24a.5.5 0 010-1h3.994c-.031-1.544-.191-5.534-.991-9.211a23.016 23.016 0 00-.657-2.425l-1.49 1.49a.497.497 0 01-.707 0l-1.646-1.646-1.646 1.646a.501.501 0 01-.708 0l-1.493-1.493a23.037 23.037 0 00-.609 2.221c1.319.803 2.346 2.409 3.056 4.775.764 2.548.894 5.094.896 5.119A.502.502 0 0116.5 24H6.045a.991.991 0 01-.77-.359.994.994 0 01-.228-.73C5.258 20.585 6.313 13 11 13c.379 0 .753.055 1.117.165C13.218 8.41 15.028 6 17.5 6c2.544 0 4.388 2.549 5.481 7.577.818 3.764.981 7.83 1.013 9.403a.993.993 0 01-.279.713.994.994 0 01-.701.307H19zm-8-10c-1.6 0-2.878 1.219-3.797 3.623-.795 2.078-1.076 4.453-1.16 5.377h9.916c-.086-.918-.348-3.053-1.026-5.002C14.009 15.345 12.685 14 11 14zm6.503-4a.5.5 0 01.354.146l1.646 1.646 1.459-1.459C20.039 8.122 18.875 7 17.5 7c-1.355 0-2.549 1.151-3.46 3.33l1.463 1.463 1.646-1.646a.496.496 0 01.354-.147z"
    }), _react2.default.createElement("path", {
      className: "landmark-mountain_svg__path1",
      d: "M2.133 7.003A2.14 2.14 0 010 4.893a2.1 2.1 0 01.962-1.778c.322-.209.69-.326 1.068-.341A3.581 3.581 0 015.527 0h.034a3.49 3.49 0 013.016 1.708 2.629 2.629 0 011.65.769c.5.501.774 1.166.773 1.873a2.72 2.72 0 01-2.371 2.646.421.421 0 01-.062.004H2.224l-.091.003c.001 0 0 0 0 0zm-.019-3.23A1.118 1.118 0 001 4.887a1.128 1.128 0 001.117 1.116l.082-.002L8.534 6A1.717 1.717 0 0010 4.341a1.63 1.63 0 00-.48-1.158 1.632 1.632 0 00-1.164-.484l-.065.001a.503.503 0 01-.468-.284A2.493 2.493 0 005.588 1h-.027C4.205 1 3.067 2.034 2.947 3.353a.5.5 0 01-.603.444 1.109 1.109 0 00-.23-.024z"
    })));
    return _this;
  }
  return IconLandmarkMountain;
}(_Icon3.default);
exports.default = IconLandmarkMountain;